export default __webpack_public_path__ + "static/media/Pray-2.02c931e2.svg";